import type { FC } from 'react';
import { useEffect } from 'react';
import type { ChampionshipSB } from '@mwl/core-lib';
import { loadChampionshipsRequest, selectChampionships, selectChampionshipsIsLoading, selectUserCurrency, useItemsFilteredByStage, useSportUrlParams } from '@mwl/core-lib';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import { FilterPopup } from '../FilterPopup/FilterPopup';
import type { ChampionshipFilterPopupProps } from './ChampionshipFilterPopup.types';
export const ChampionshipFilterPopup: FC<ChampionshipFilterPopupProps> = ({
  show,
  onClose
}) => {
  const dispatch = useTypedDispatch();
  const currency = useTypedSelector(selectUserCurrency);
  const data = useTypedSelector(selectChampionships);
  const isLoading = useTypedSelector(selectChampionshipsIsLoading);
  const {
    sportId,
    categoryIds,
    championshipIds,
    setFilters,
    stage
  } = useSportUrlParams();
  const handleSubmit = (ids: Array<string>) => {
    setFilters({
      championshipIds: ids,
      championshipId: ''
    });
    onClose();
  };
  const filteredChampionships = useItemsFilteredByStage<ChampionshipSB>(data ?? [], stage);
  useEffect(() => {
    if (show && currency) {
      dispatch(loadChampionshipsRequest({
        sportIds: sportId ? [sportId] : [],
        categoryIds: categoryIds ?? []
      }));
    }
  }, [categoryIds, currency, dispatch, show, sportId]);
  return <FilterPopup type="championship" show={show} onClose={onClose} isLoading={isLoading} defaultSelected={championshipIds ?? []} items={filteredChampionships} onSubmit={handleSubmit} data-sentry-element="FilterPopup" data-sentry-component="ChampionshipFilterPopup" data-sentry-source-file="ChampionshipFilterPopup.tsx" />;
};